import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { MenuItem, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import '../ticketKnowledge/DrilldownAndDetailSearch.css';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { I18n } from 'aws-amplify';
import './ShareFormField.css';

export default function ShareForm({ props, argsAll }) {
    const [shareOption, setShareOption] = useState();
    const [isShareDestination, setIsShareDestination] = useState(false);
    const [isOrgsSelected, setIsOrgsSelected] = useState(false);

    const [listOrg, setListOrg] = useState([]);
    const [selectedOrgs, setSelectedOrgs] = useState([]);

    const formEdit = argsAll?.formEdit;
    const onChangeSelectedOrgs = (_, value) => {
        setSelectedOrgs(value);
        argsAll.setShareDestination(value);
        setIsOrgsSelected(true);
        if (value.length > 0) {
            argsAll.setIsChangeData(true);
        } else {
            argsAll.setIsChangeData(false);
        }
    };

    const onChangeShareOption = event => {
        setSelectedOrgs([]);
        let shareOptionValue = event.target.value;
        setShareOption(shareOptionValue);

        argsAll.setShareDestination([]);
        argsAll.setShareOptionValue(shareOptionValue);

        setIsOrgsSelected(false);

        if (
            [
                Constant.SHARE_OPTION.SPECIFIC_ORG,
                Constant.SHARE_OPTION.B2B_CUSTOMER_ORG,
                Constant.SHARE_OPTION.B2B_HELPDESK_ORG
            ].includes(shareOptionValue)
        ) {
            argsAll.setIsChangeData(false);
        } else {
            argsAll.setIsChangeData(true);
        }
    };

    const filterSugguestionOption = createFilterOptions({
        ignoreCase: false,
        stringify: option => `${option.title} ${option.subDomain}`
    });

    const getOrgListFromShareOption = value => {
        if (value === Constant.SHARE_OPTION.SPECIFIC_ORG) {
            return props.allListCorp;
        }
        if (value === Constant.SHARE_OPTION.B2B_CUSTOMER_ORG) {
            return props.b2bCustomerList;
        }
        if (value === Constant.SHARE_OPTION.B2B_HELPDESK_ORG) {
            return props.b2bHelpDeskList;
        }
        return [];
    };

    useEffect(() => {
        
        let orgList = getOrgListFromShareOption(shareOption);
        setListOrg(orgList);
        let isAddForm = argsAll?.panelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM;
        let isDuplicateForm = argsAll?.panelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM && argsAll?.isDuplicateForm;
        let isEditForm = argsAll?.panelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM && !argsAll?.isDuplicateForm;

        let isShowShareDestination =
            isAddForm ||
            isDuplicateForm ||
            (isEditForm &&
                argsAll?.corporationId === argsAll?.formEdit?.affiliationOrganization &&
                argsAll?.projectInuseId === argsAll?.formEdit?.affiliationProject);

        
        if (orgList.length > 0) {
            if (!(argsAll?.addFormType === Constant.FORM_TYPE.FORM_TASK || formEdit?.type === Constant.FORM_TYPE.FORM_TASK)) {
                setIsShareDestination(true);
            } else {
                if (isShowShareDestination) {
                    setIsShareDestination(true);
                } else {
                    setIsShareDestination(false);
                }
            }
            setIsShareDestination(true);
        } else {
            setIsShareDestination(false);
        }
        argsAll.setShareOptionValue(shareOption);
    }, [shareOption]);

    useEffect(() => {
        let defaultOption = formEdit?.shareOption ? formEdit?.shareOption : 1;
        if (defaultOption) setShareOption(defaultOption);
        if (formEdit?.shareRange) {
            let orgList = getOrgListFromShareOption(defaultOption);
            let selectOrg = [];
            orgList.forEach(org => {
                if (formEdit.shareRange.includes(org.id)) {
                    if (org.active !== Constant.CORPORATION_ACTIVE.DELETED) {
                        selectOrg.push(org);
                    }
                }
            });

            if (selectOrg.length > 0) {
                setSelectedOrgs(selectOrg);
                argsAll.setShareDestination(selectOrg);
            }
        }
    }, []);

    const filterBlockAndDeleteOrg = orgList => {
        return orgList?.filter(
            org =>
                org.active !== Constant.CORPORATION_ACTIVE.BLOCK &&
                org.active !== Constant.CORPORATION_ACTIVE.DELETED
        );
    };

    const filterListOrgToShare = (orgList) => {
        if (argsAll?.addFormType === Constant.FORM_TYPE.FORM_TASK || formEdit?.type === Constant.FORM_TYPE.FORM_TASK) {
            return orgList?.filter(
                org =>
                    org.active !== Constant.CORPORATION_ACTIVE.DELETED &&
                    org.contractType !== Constant.CORPORATION_CONTRACT_TYPE.GUEST
            );
        }
        return filterBlockAndDeleteOrg(orgList);
    }
    
    const isShowValueOptionB2BCustomer = () => {
        let isEditForm = argsAll?.panelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM && !argsAll?.isDuplicateForm;
        if (isEditForm && (argsAll?.corporationId !== argsAll?.formEdit?.affiliationOrganization || argsAll?.projectInuseId !== argsAll?.formEdit?.affiliationProject )) {
            return true;
        } else {
            return !Utils.isEmptyArray(props.b2bCustomerList);
        }
    }

    const isShowValueOptionB2BHelpDesk = () => {
        let isEditForm = argsAll?.panelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM && !argsAll?.isDuplicateForm;
        if (isEditForm && (argsAll?.corporationId !== argsAll?.formEdit?.affiliationOrganization || argsAll?.projectInuseId !== argsAll?.formEdit?.affiliationProject )) {
            return true;
        } else {
            return !Utils.isEmptyArray(props.b2bHelpDeskList);
        }
    }

    return (
        <>
            <div className="lstCreateForm padding-0">
                <p className="share-option-text">共有範囲</p>
                <div className="share-option-control">
                    <TextField
                        name="share-option"
                        className="form-control--wrap form-control--hg32"
                        select
                        variant="outlined"
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null,
                                className: 'selectDrop'
                            }
                        }}
                        value={shareOption}
                        onChange={onChangeShareOption}
                        defaultValue={
                            formEdit && formEdit?.shareOption
                                ? formEdit.shareOption
                                : Constant.SHARE_OPTION.INTERNAL_ORG
                        }
                        disabled={argsAll.isFormReadOnly}
                    >
                        <MenuItem value={Constant.SHARE_OPTION.INTERNAL_ORG}>組織内</MenuItem>
                        <MenuItem value={Constant.SHARE_OPTION.SPECIFIC_ORG}>特定の他組織</MenuItem>
                        {/* {isShowValueOptionB2BCustomer() && ( */}
                            <MenuItem value={Constant.SHARE_OPTION.B2B_CUSTOMER_ORG}>
                                B2Bカスタマー組織
                            </MenuItem>
                        {/* )} */}
                        {/* {isShowValueOptionB2BHelpDesk() && ( */}
                            <MenuItem value={Constant.SHARE_OPTION.B2B_HELPDESK_ORG}>
                                B2Bサポート組織
                            </MenuItem>
                        {/* )} */}
                        <MenuItem value={Constant.SHARE_OPTION.ALL_ORG}>全組織</MenuItem>
                    </TextField>
                </div>
            </div>
            {isShareDestination && (
                <div className="lstCreateForm padding-0">
                    <label className="share-option-text">共有先</label>
                    <div className="share-option-control">
                        <Autocomplete
                            className="search-option-tag-content"
                            multiple
                            filterSelectedOptions
                            filterOptions={filterSugguestionOption}
                            getOptionLabel={(option) => {
                                let label = option.active === Constant.CORPORATION_ACTIVE.BLOCK ? `${option?.title} ${option?.subDomain} (停止中)` : `${option?.title} ${option?.subDomain}`
                                return label
                            }}
                            options={filterListOrgToShare(listOrg)}
                            value={selectedOrgs}
                            onChange={onChangeSelectedOrgs}
                            disabled={argsAll.isFormReadOnly}
                            renderInput={params => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    className="form-control"
                                    placeholder={I18n.get('USER04P009')}
                                    error={isOrgsSelected && selectedOrgs.length === 0}
                                    helperText={
                                        isOrgsSelected && selectedOrgs.length === 0
                                            ? I18n.get('COMMSG014')
                                            : ''
                                    }
                                />
                            )}
                            ListboxProps={{
                                style: {
                                    maxHeight: 376,
                                    overflow: 'auto',
                                    overflowX: 'hidden'
                                }
                            }}
                            noOptionsText={I18n.get('COMMSG001')}
                        ></Autocomplete>
                    </div>
                </div>
            )}
        </>
    );
}
